import {
    NinchatActionType,
    NinchatRequestIdentityAuthResetAccessAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const requestIdentityAuthResetAccess = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatRequestIdentityAuthResetAccessAction}`,
    async (arg: NinchatActionParams<NinchatRequestIdentityAuthResetAccessAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatRequestIdentityAuthResetAccessAction

        try {
            return await ninchatClient.call(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
